import ApiClient from './ApiClient';
class AgentBotsAPI extends ApiClient {
  constructor() {
    super('agent_bots', { accountScoped: true });
  }
}

export default new AgentBotsAPI();;
